import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";

import { HELP_CUSTOM_DESTINATIONS } from "@/constants/HelpUrls";
import MasterDetail from "@/design/layouts/MasterDetail";
import { setHelpUrl } from "@/store/reducers/ui";

import { useHotkey } from "@tanstack/react-hotkeys";

import Destination from "./Destination";
import DestinationList from "./DestinationList";

export default function Destinations() {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setHelpUrl(HELP_CUSTOM_DESTINATIONS));
  }, [dispatch]);

  useHotkey("Alt+N", () => navigate(`/pbx/${params.pbxId}/call-flow/custom-destinations/new`));

  return <MasterDetail identifier="id" master={<DestinationList />} detail={<Destination />} />;
}
